import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ForceOrganisationState } from './reducer';

export const selectForceOrganisationState =
    createFeatureSelector<ForceOrganisationState>('forceOrganisation');

export const selectForceOrganisation = (gameId: string) =>
    createSelector(selectForceOrganisationState, (s) => s?.[gameId] ?? null);

export const selectViewMode = (gameId: string) =>
    createSelector(selectForceOrganisation(gameId), (d) => d?.viewMode ?? 'faction');

export const selectFolders = (gameId: string) =>
    createSelector(selectForceOrganisation(gameId), (d) => d?.folders ?? []);

export const selectOrgItems = (gameId: string) =>
    createSelector(selectForceOrganisation(gameId), (d) => d?.items ?? []);
